/**
 * Interceptor
 * This is HttpTokenInterceptor that adds a token to each api request.
 */


import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JWTAuthService } from '@core/services/jwt-auth.service';
import { TOKEN_HEADER_KEY, AUTH_PREFIX } from '@configs/app-settings.config';
import { CommonBase } from "@core/interfaces/common-base";
import { isExternalUrl } from '../helpers/utils';

/**
 * intercept the http request
 * Creates a HttpTokenInterceptor.
 * @class HttpTokenInterceptor
 * @classdesc This class is used to add user token/auth entity to the headers.
 * You can define the custom header here.
 */

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(private authService: JWTAuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isExternalUrl(req.url)) {
      const headersConfig: CommonBase = {
        'Accept': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
      };
      if (!(req.body instanceof FormData)) {
        headersConfig['Content-Type'] = 'application/json'
      }
      const token: null | CommonBase = this.authService.getUserAccessToken();
      if (token) {
        headersConfig[TOKEN_HEADER_KEY] = `${AUTH_PREFIX} ${token}`;
      }
      req = req.clone({ setHeaders: headersConfig });
    }
    return next.handle(req);
  }
}

